module.exports = __webpack_public_path__ + "static/media/Cotisations1.52072d6d.pdf";